import React from 'react'
import { Helmet } from 'react-helmet'
import { useDevTools } from 'global/context/sub-contexts/devToolsContext'
import { cssColor } from '../../../utils/cssValues'

// A break with no themeColor3/4 must not publish the literal `undefined`: an unset custom
// property lets a consumer's var(--x, fallback) apply, an `undefined` one silently voids it.
// This is CSS text, so a colour goes in only when it is valid CSS colour syntax: any other
// value could close the rule and add rules of its own (BR-5693).
const decl = (name, value) => {
  const color = cssColor(value)
  return color ? `${name}: ${color};` : ''
}

// The selected-answer circle follows the button colour. Its default, var(--theme-color-primary),
// resolves on <body>, where it is still Dailybreak purple, so it has to be set here on main.
const buildInlineStyle = brk => `
body main.sponsored {
  ${decl('background-color', brk.themeColor1)}
  ${decl('color', brk.themeColor2)}

  ${decl('--text-color-primary', brk.themeColor2)}
  ${decl('--theme-color-button', brk.themeColor3)}
  ${decl('--button-text-color-primary', brk.themeColor4)}
  ${decl('--quiz-answer-check-background', brk.themeColor3)}
}

main.sponsored .themed-button,
main.sponsored .themed-button:hover {
    ${decl('background-color', brk.themeColor3)}
    ${decl('color', brk.themeColor4)}
    ${decl('border-color', brk.themeColor3)}
}

main.sponsored .themed-button-secondary {
  background-color : transparent;
  ${decl('color', brk.themeColor4)}
  ${cssColor(brk.themeColor3) ? `border : 2px solid ${cssColor(brk.themeColor3)};` : ''}
}

.sponsored .themed-secondary {
  background-color : ${cssColor(brk.themeColor5) ?? '#EEEAF4'};
  color : ${cssColor(brk.themeColor6) ?? '#646464'};
}
`

export const BreakThemeProvider = ({ brk, isEmbed, inline = false }) => {
  const { customCssDisabled } = useDevTools()
  return (
    <>
      <Helmet
        bodyAttributes={{
          // `is-embed` styles the break as a standalone page with no site
          // chrome: the step nav is pinned to the viewport top. Rendered inline
          // inside a page that has its own header, that nav covers the header,
          // so an inline break takes the `no-embed` layout regardless of
          // `isEmbed`, which only governs the guest auth flow.
          class: `sponsored ${
            isEmbed && !inline ? 'is-embed' : 'no-embed'
          } ${brk.permalink}`,
        }}
      />
      {brk.customCss && !customCssDisabled && (
        <style dangerouslySetInnerHTML={{ __html: brk.customCss }} />
      )}
      <style dangerouslySetInnerHTML={{ __html: buildInlineStyle(brk) }} />
    </>
  )
}
